<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <div class="timeSearch">
                            <span style="color: #b2b2b2;">入驻时间</span>
                            <el-date-picker
                                v-model="createDateValue"
                                @change="chooseDate"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="—"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            >
                            </el-date-picker>
                        </div>
                        <el-input v-model="shopName" clearable placeholder="商家名称"></el-input>
                        <el-select clearable v-model="statusValue" placeholder="状态">
                            <el-option
                                label="待审核"
                                value="SUBMIT">
                            </el-option>
                            <el-option
                                label="审核通过"
                                value="APPROVE">
                            </el-option>
                            <el-option
                                label="审核拒绝"
                                value="REJECT">
                            </el-option>
                        </el-select>
                        <el-cascader
                            clearable
                            v-model="areaValue"
                            :options="provinceOptions"
                            clearable placeholder="省/市/区"></el-cascader>
                        <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="name"
                                label="商家"
                                header-align="center"
                                width="250"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="address"
                                label="地区"
                                header-align="center"
                                :formatter="shopDetailAddress"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="入驻时间"
                                header-align="center"
                                show-overflow-tooltip
                                width="200"
                                align="center">
                            </el-table-column>
                            <!--<el-table-column
                                prop="sort"
                                align="center"
                                header-align="center"
                                label="推荐位" width="200">
                            </el-table-column>-->
                            <el-table-column
                                prop="status"
                                align="center"
                                header-align="center"
                                :formatter="showExamineStatus"
                                label="状态" width="200">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center"
                                width="230">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.status=='SUBMIT'" @click="toDialog(0,scope.row.uuid)">审核</el-button>
                                    <el-button type="text" size="small" @click="toDialog(1,scope.row.uuid)">查看</el-button>
                                    <!--<el-button type="text" size="small" v-if="scope.row.examineStatus === 'PASS'" @click="setSortInfo(scope.row)">推荐位</el-button>-->
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!--审核查看弹出框-->
        <!--<el-dialog v-loading="loading"
                   :title="title"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   width="800px">
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <h3>公司联系人</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">法人身份证:</div>
                                <img style="width: 216px;height:137px" src="@/assets/images/13哆啦A梦.png" alt="">
                            </div>
                            <div class="one-row">
                                <img style="width: 216px;height:137px" src="@/assets/images/13哆啦A梦.png" alt="">
                            </div>
                            <div class="one-row">
                                <div class="label">法人姓名:</div>
                                <div class="name">法人姓名</div>
                            </div>
                            <div class="one-row">
                                <div class="label">法人证件号码:</div>
                                <div class="name">法人证件号码</div>
                            </div>
                           <div class="one-row">
                                <div class="label">联系人姓名:</div>
                                <div class="name">{{ shopSettled.contact }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系人电话:</div>
                                <div class="name">{{ shopSettled.contactTel }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系人邮箱:</div>
                                <div class="name">{{ shopSettled.contactMail }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">客服电话:</div>
                                <div class="name">2313213</div>
                            </div>
                        </div>
                    </div>
                    &lt;!&ndash; <div class="detailsItem">
                        <h3>开户行</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">银行名称:</div>
                                <div class="name">{{ shopSettled.bankName }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">开户银行支行:</div>
                                <div class="name">{{ shopSettled.bankSubbranch }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">开户名:</div>
                                <div class="name">{{ shopSettled.bankType }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">银行账号:</div>
                                <div class="name">{{ shopSettled.bankAccount }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">开户支行联行号:</div>
                                <div class="name">{{ shopSettled.accountBankSubbranch }}</div>
                            </div>
                        </div>
                    </div> &ndash;&gt;
                    <div class="detailsItem">
                        <h3>店铺信息</h3>
                        <div class="itemContent">
                            <div class="two-row">
                                <div class="label">店铺名称:</div>
                                <div class="name">{{ shopSettled.name }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">店铺地址:</div>
                                <div class="name">{{ shopSettled | ellipsisProvider }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">企业类型:</div>
                                <div class="name">企业类型</div>
                            </div>
                            <div class="two-row">
                                <div class="label">开户许可证编号:</div>
                                <div class="name">开户许可证编号</div>
                            </div>
                            <div class="two-row">
                                <div class="label">企业名称:</div>
                                <div class="name">企业名称</div>
                            </div>
                            <div class="two-row">
                                <div class="label">统一信用代码:</div>
                                <div class="name">4151325135342</div>
                            </div>
                            <div class="two-row">
                                <div class="label">营业执照:</div>
                                <img style="width: 184px;height: 216px" src="@/assets/images/13哆啦A梦.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem">
                        <h3>结算信息</h3>
                        <div class="itemContent">
                            <div class="two-row">
                                <div class="label">银行账户类型:</div>
                                <div class="name">银行账户类型</div>
                            </div>
                            <div class="two-row">
                                <div class="label">开户行:</div>
                                <div class="name">开户行</div>
                            </div>
                            <div class="two-row">
                                <div class="label">银行账户号码:</div>
                                <div class="name">银行账户号码</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 1">
                    <h3>审核结果</h3>
                    <div class="auditContent">
                        <el-tag type="success" effect="dark" v-if="shopSettled.status=='APPROVE'">审核已通过</el-tag>
                        <el-tag type="danger" effect="dark" v-if="shopSettled.status=='REJECT'">审核已驳回</el-tag>
                        <div class="cause" v-if="shopSettled.status=='REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent">{{ shopSettled.remark }}</div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 0">
                    <h3>审核</h3>
                    <div class="auditContent">
                        <el-radio-group v-model="examineStatus">
                            <el-radio label="APPROVE">通过</el-radio>
                            <el-radio label="REJECT">驳回</el-radio>
                        </el-radio-group>
                        <div class="cause" v-if="examineStatus === 'REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" style=" width: 100%;">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 5}"
                                    placeholder="请输入驳回原因"
                                    v-model="remark">
                                </el-input>
                            </div>
                        </div>
                        <div class="auditEnter">
                            <el-button type="primary" @click="auditSubmit(shopSettled.uuid)">确定</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>-->
        <el-dialog v-loading="loading"
                   :title="title"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   width="800px">
            <div class="dialogBox">
                <div class="details">
                    <div class="detailsItem">
                        <h3>公司联系人</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">联系人姓名:</div>
                                <div class="name">{{ shopSettled.contact }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系人电话:</div>
                                <div class="name">{{ shopSettled.contactTel }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">联系人邮箱:</div>
                                <div class="name">{{ shopSettled.contactMail }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem">
                        <h3>开户行</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">银行名称:</div>
                                <div class="name">{{ shopSettled.bankName }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">开户银行支行:</div>
                                <div class="name">{{ shopSettled.bankSubbranch }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">开户名:</div>
                                <div class="name">{{ shopSettled.bankType }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">银行账号:</div>
                                <div class="name">{{ shopSettled.bankAccount }}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">开户支行联行号:</div>
                                <div class="name">{{ shopSettled.accountBankSubbranch }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem">
                        <h3>店铺信息</h3>
                        <div class="itemContent">
                            <div class="two-row">
                                <div class="label">店铺名称:</div>
                                <div class="name">{{ shopSettled.name }}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">店铺地址:</div>
                                <div class="name">{{ shopSettled | ellipsisProvider }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 1">
                    <h3>审核结果</h3>
                    <div class="auditContent">
                        <el-tag type="success" effect="dark" v-if="shopSettled.status=='APPROVE'">审核已通过</el-tag>
                        <el-tag type="danger" effect="dark" v-if="shopSettled.status=='REJECT'">审核已驳回</el-tag>
                        <div class="cause" v-if="shopSettled.status=='REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent">{{ shopSettled.remark }}</div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 0">
                    <h3>审核</h3>
                    <div class="auditContent">
                        <el-radio-group v-model="examineStatus">
                            <el-radio label="APPROVE">通过</el-radio>
                            <el-radio label="REJECT">驳回</el-radio>
                        </el-radio-group>
                        <div class="cause" v-if="examineStatus === 'REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" style=" width: 100%;">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 5}"
                                    placeholder="请输入驳回原因"
                                    v-model="remark">
                                </el-input>
                            </div>
                        </div>
                        <div class="auditEnter">
                            <el-button type="primary" @click="auditSubmit(shopSettled.uuid)">确定</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 设置推荐位 -->
        <el-dialog
            title="设置推荐位"
            :visible.sync="sortDialogVisible"
            width="800px">
            <div class="dialogContent">
                <el-form :rules="rules" :model="ruleForm" ref="ruleForm" label-width="120px">
                    <el-form-item prop="sort" label="推荐位">
                        <el-input-number v-model="ruleForm.sort"  :min="1"></el-input-number>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getShopSettledList,getShopSettledInfo,
        auditShopper,setProvidersSort } from '../../../utils/interface';
    export default {
        components: {},
        data() {
            return {
                loading: false,
                startTime:"",
                endTime:"",
                createDateValue: null,
                typeValue: '',
                shopName:'',
                areaValue:'',
                province:'',
                city:'',
                district:'',
                statusValue: '',
                provinceOptions: this.provinceData,
                tableData: [],
                current:1,
                total: 0,
                pageSize: 8,
                dialogVisible: false,
                title: '',
                examineStatus: '',
                remark: '',
                currentAudit: '',
                shopSettled:'',
                ruleForm:{
                    sort:'',
                },
                rules: {
                    sort: [
                        {required: true, message: '请设置排序', trigger: 'change'}
                    ],
                },
                sortDialogVisible:false,
                info:"",
                orderBy:"status_descend",
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120;
                return {minHeight: height + 'px'}
            },
        },
        filters: {
            ellipsisProvider(result) {
                let address = "";
                if(result.province!=""){
                    address = address + result.province;
                }
                if(result.city!=""){
                    address = address + result.city;
                }
                if(result.district!=""){
                    address = address + result.district;
                }
                if(result.address!=""){
                    address = address + result.address;
                }
                return address;
            }
        },
        created(){
            this.getShopSettledList();
        },
        methods: {
            // 时间格式
            chooseDate(){
                this.startTime = "";
                this.endTime = "";
                // 判断时间
                if(this.createDateValue!=null && this.createDateValue.length==2){
                    this.startTime = this.timeDate(this.createDateValue[0]);
                    this.endTime = this.timeDate(this.createDateValue[1]);
                }
            },
            timeDate(value){
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? "0" + MM : MM;
                let d = date.getDate();
                d = d < 10 ? "0" + d : d;
                return y + "-" + MM + "-" + d;
            },
            showExamineStatus(row, column){
                if(row.status=="APPROVE"){
                    return "审核通过";
                }else if(row.status=="SUBMIT"){
                    return "待审核";
                }else if(row.status=="REJECT"){
                    return "审核拒绝";
                }
            },
            shopDetailAddress(row, column){
                let address = "";
                if(row.province!=""){
                    address = address + row.province;
                }
                if(row.city!=""){
                    address = address + row.city;
                }
                if(row.district!=""){
                    address = address + row.district;
                }
                if(row.address!=""){
                    address = address + row.address;
                }
                return address;
            },
            getShopSettledList(){
                let params = {
                    current:this.current,
                    pageSize:this.pageSize,
                    name:this.shopName,
                    status:this.statusValue,
                    orderBy:this.orderBy,
                    startDate:this.startTime,
                    endDate:this.endTime,
                    province:this.province,
                    city:this.city,
                    district:this.district,
                };
                getShopSettledList(params).then((res)=>{
                    this.tableData = res.list;
                    this.total = res.total;
                    this.pageSize = res.size;
                    this.current = res.current;
                });
            },
            searchInfo(){
                if(this.areaValue != null && this.areaValue.length == 3){
                    this.province = this.areaValue[0];
                    this.city = this.areaValue[1];
                    this.district = this.areaValue[2];
                } else if(this.areaValue != null && this.areaValue.length == 2){
                    this.province = this.areaValue[0];
                    this.city = this.areaValue[1];
                }
                this.current = 1;
                this.getShopSettledList();
            },
            resetData(){
                this.province = '';
                this.city = '';
                this.district = '';
                this.startTime = "";
                this.endTime = "";
                this.createDateValue = null;
                this.typeValue = '';
                this.areaValue = '';
                this.statusValue = '';
                this.shopName='';
                this.searchInfo();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getShopSettledList();
            },
            // 审核查看
            toDialog(val,uuid){
                this.dialogVisible = true;
                this.loading = true;
                this.currentAudit = val;
                if(val === 0){
                    this.title = '审核详情';
                    this.examineStatus = '';
                    this.remark = '';
                } else {
                    this.title = '查看详情'
                }
                this.shopSettled = {};
                getShopSettledInfo(uuid).then((res)=>{
                    this.shopSettled = res;
                    this.loading = false;

                });
            },
            // 确定审核
            auditSubmit(uuid){
                if(this.examineStatus === ''){
                    this.$message.warning('请选择审核结果！');
                } else if(this.examineStatus === 'REJECT' && this.remark === ''){
                    this.$message.warning('请输入驳回原因！');
                } else {
                    let params = {
                        uuid:uuid,
                        remark:this.remark,
                        status:this.examineStatus,
                    };
                    auditShopper(params).then((res)=>{
                        this.$message.success('审核成功！');
                        this.dialogVisible = false;
                        this.getShopSettledList();
                    });
                }
            },
            setSortInfo(item){
                this.info = item;
                if(item.sort!=""){
                    this.ruleForm.sort = item.sort;
                }
                this.sortDialogVisible = true;
            },
            submit(){
                this.info.sort = this.ruleForm.sort;
                setProvidersSort({uuid:this.info.uuid,sort:this.ruleForm.sort}).then((res)=>{
                    if(res.success) {
                        this.$message.success('设置成功！');
                        this.sortDialogVisible = false;
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    .timeSearch {
                        background-color: #f2f4f7;
                        height: 35px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 22px;
                        margin-right: 30px;
                        border-radius: 8px;

                        span {
                            font-size: 12px;
                            color: #c0c4cc !important;
                            font-weight: normal;
                            padding-left: 15px;
                            margin-right: 5px;
                        }

                        // /deep/ .el-range-input{
                        //         background-color: #f2f4f7;
                        //             &:hover, &:focus {
                        //             background-color: #fff;
                        //             // border: 1px solid #108EE9;
                        //         }
                        // }
                        /deep/ input::-webkit-input-placeholder {
                            color: #c0c4cc;
                            font-size: 12px;
                        }

                        /deep/ .el-range-input:hover {
                            background-color: #fff !important;
                        }

                        /deep/ .el-date-editor .el-range-separator {
                            line-height: 25px;
                            color: #c0c4cc;
                        }

                        /deep/ .el-date-editor .el-range__close-icon {
                            line-height: 28px;
                        }

                        /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                            background-color: white;
                        }

                        /deep/ .el-input__inner {
                            width: 225px;
                            height: 35px;
                            min-height: 35px;
                            font-size: 12px;
                            color: #999999;
                            background-color: #f2f4f7;
                            border: 1px solid #f2f4f7;
                            border-radius: 5px;

                            .el-range-input {
                                background-color: #f2f4f7;
                            }

                            &:hover, &:focus {
                                background-color: #fff;
                                border: 1px solid #108EE9;

                            }
                        }
                    }
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover, &:focus {
                            background-color: #fff;
                            border: 1px solid #108EE9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-bottom:22px;
                    }

                    .resetBtn {
                        color: #333333;
                        margin-bottom:22px;
                    }
                }

            }
        }

        //审核查看详情中title的样式
        /deep/.el-dialog__header{
            border-bottom: 1px solid #ddd;
            .el-dialog__title{
                color: #000;
                font-weight: 700;
                font-size: 16px;

            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        // border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        // padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            font-size: 14px;
                            .label{
                                padding-right: 15px;
                                min-width: 110px;
                                color: rgba(0, 0, 0, 0.85);
                            }
                            .name{
                                // color: #000;
                                color: rgba(0, 0, 0, 0.65);
                            }
                        }
                        .two-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            font-size: 14px;
                            .label{
                                padding-right: 15px;
                                min-width: 110px;
                                color: rgba(0, 0, 0, 0.85);
                            }
                            .name{
                                // color: #000;
                                caret-color: rgba(0, 0, 0, 0.65);
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    // padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .pagination {
        margin-top: 20px;
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/views/auditManagement/enterAudit/merchantEnter.vue